import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import backgroundImage from '../../../../assets/Images/errorBoundaryImage.jpg'
import logo from '../../../../assets/Images/logos/logodark.svg'
import {
  BoxContainer,
  BoxLogoContainer,
  BoxMessageContainer,
  BoxSurfaceGradient,
  BoxSurfaceImage,
  ButtonBack,
  DividerGradient,
  SurfacePaper
} from '../../styles/ErrorBoundaryStyles'

export default function ErrorBoundary() {
  const { t } = useTranslation(['global'])

  return (
    <BoxContainer>
      <BoxLogoContainer>
        <img src={logo} height={'35px'} alt="logo" />
      </BoxLogoContainer>
      <BoxSurfaceImage style={{ backgroundImage: `url(${backgroundImage})` }} />
      <BoxSurfaceGradient />
      <SurfacePaper elevation={0}>
        <BoxMessageContainer>
          <DividerGradient />
          <Typography sx={{ color: '#FFF' }} align="center">
            {t('common.error-message-boundary')}
          </Typography>
          <DividerGradient />
        </BoxMessageContainer>
        <ButtonBack href="/inicio" id="btn-back-to-home" variant="contained" fullWidth>
          {t('go-to-home')}
        </ButtonBack>
      </SurfacePaper>
    </BoxContainer>
  )
}
